import { render, staticRenderFns } from "./rp-sidebar-content.vue?vue&type=template&id=57e38527"
import script from "./rp-sidebar-content.vue?vue&type=script&lang=js"
export * from "./rp-sidebar-content.vue?vue&type=script&lang=js"
import style0 from "./rp-sidebar-content.vue?vue&type=style&index=0&id=57e38527&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports